// Maps a pipeline-run error into advisor-facing text + an internal code
// suitable for the audit log and support conversations.
// Advisor text is deliberately vendor-agnostic (no "Anthropic" etc.).

const STAGE_CODE = { analyst: 'ANL', specialist: 'SPEC', qa: 'QA' }

const HTTP_TEXT = {
  400: 'Request rejected before the review could start · check the console for details',
  401: 'Authentication failed · please refresh and try again',
  404: 'Client or resource not found · try refreshing the page',
  422: 'The Specialist could not parse the policy · try a different PDF or retry',
  429: 'API rate limit exceeded · please retry in a few minutes',
  500: 'An unexpected error occurred · please retry',
  502: 'Upstream service unavailable · please retry shortly',
  503: 'Service temporarily unavailable · please retry shortly',
  504: 'The request timed out · please retry'
}

const KNOWN_STATUS = new Set([400, 401, 404, 422, 429, 500, 502, 503, 504])

export function mapPipelineError({ httpStatus, stage } = {}) {
  const stageCode = STAGE_CODE[stage] || 'ALL'
  const status = KNOWN_STATUS.has(httpStatus) ? httpStatus : 500
  return {
    advisorText: HTTP_TEXT[status],
    internalCode: `IR-PIPE-${status}-${stageCode}`
  }
}
